import { render, staticRenderFns } from "./industryCostAscription.vue?vue&type=template&id=8110f89a&scoped=true"
import script from "./industryCostAscription.vue?vue&type=script&lang=js"
export * from "./industryCostAscription.vue?vue&type=script&lang=js"
import style0 from "./industryCostAscription.vue?vue&type=style&index=0&id=8110f89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8110f89a",
  null
  
)

export default component.exports